<template>
  <div class="services-details-bg pt-120 pb-100">
    <div class="container">
      <!-- Images: Side-by-side, right-aligned -->
      <div class="services-details-img d-flex gap-3 mb-4 flex-wrap justify-content-end">
        <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" 
          src="../../assets/images/ser3.jpg"
          alt="Digital Media Marketing"
          class="top-banner-img"
        />
        <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" 
          src="../../assets/images/sera3.jpg"
          alt="Digital Media Marketing"
          class="top-banner-img"
        />
      </div>

      <div class="row">
        <div class="col-lg-8">
          <div class="services-details-content pt-4">
            <h2 title="We connect brands with celebrities and influencers for powerful digital campaigns.">Digital Media Marketing</h2>

            <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">Manage. Grow. Monetize.</h3>
            <p>
              At <strong>MyCelebrity by Digitalentio</strong>, we help brands, influencers, and public figures grow their presence across Instagram, Facebook, WhatsApp, and YouTube. From content creation to daily management — we turn your social profiles into powerful marketing machines.
            </p>

            <div class="mb-lg-5 mb-4"></div>

            <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">What We Offer:</h3>

            <h4 title="We connect brands with celebrities and influencers for powerful digital campaigns.">Instagram Management</h4>
            <ul>
              <li><b>Content strategy</b> (reels, posts, stories, carousels)</li>
              <li><b>Hashtag & trend research</b></li>
              <li><b>Influencer collaborations</b></li>
              <li><b>Monthly growth reports & audience insights</b></li>
              <li><b>Comment, DM & engagement management</b></li>
            </ul>

            <h4 title="We connect brands with celebrities and influencers for powerful digital campaigns.">Facebook Page Management</h4>
            <ul>
              <li><b>Page optimization & content scheduling</b></li>
              <li><b>Facebook ads setup & targeting</b></li>
              <li><b>Community engagement</b></li>
              <li><b>Cross-platform integration</b> with Instagram & WhatsApp</li>
              <li><b>Event promotion & live campaigns</b></li>
            </ul>

            <h4 title="We connect brands with celebrities and influencers for powerful digital campaigns.">WhatsApp Business Marketing</h4>
            <ul>
              <li><b>WhatsApp Business setup & green badge support</b></li>
              <li><b>Auto-response & broadcast message setup</b></li>
              <li><b>Catalog creation & API integration</b></li>
              <li><b>Customer support automation</b></li>
              <li><b>CRM integration</b> for sales & lead generation</li>
            </ul>

            <h4 title="We connect brands with celebrities and influencers for powerful digital campaigns.">YouTube Channel Management</h4>
            <ul>
              <li><b>Video content planning & posting</b></li>
              <li><b>SEO optimization</b> (titles, tags, thumbnails, descriptions)</li>
              <li><b>Shorts strategy</b> for quick growth</li>
              <li><b>Monetization support & brand integrations</b></li>
              <li><b>Channel analytics & performance tracking</b></li>
            </ul>

            <div class="mb-lg-5 mb-4"></div>

            <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">Why Brands Trust Us:</h3>
            <ul>
              <li><b>Platform-specific strategies</b> for real results</li>
              <li><b>Creative + data-driven</b> content approach</li>
              <li><b>Consistent growth, engagement & visibility</b></li>
              <li><b>Dedicated social media team</b> and account manager</li>
            </ul>
          </div>
        </div>

        <div class="col-lg-4 mt-4 mt-lg-0">
          <ServicesSidebar />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ServicesSidebar from "@/components/ServiceDetails/ServivesSidebar.vue";

export default {
  name: "ServicesDetails",
  components: {
    ServicesSidebar,
  },
};
</script>

<style lang="scss" scoped>
// Light theme (default)
:deep(body):not(.theme-dark) {
  .services-details-bg {
    background-color: #fff;
    color: #000;
  }
}

// Dark theme
:deep(body.theme-dark) {
  .services-details-bg {
    background-color: #111;
    color: #fff;
  }
}

.services-details-bg {
  padding-top: 180px;
  padding-bottom: 100px;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.services-details-img {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: flex-end;

  .top-banner-img {
    width: 48%;
    max-width: 100%;
    max-height: 400px;
    object-fit: cover;
    border-radius: 20px;
    display: block;
  }
}

.services-details-content {
  padding-top: 20px;

  h2 {
    font-size: 36px;
    margin-bottom: 25px;
  }

  h3 {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 15px;
  }

  h4 {
    font-size: 18px;
    font-weight: 600;
    margin-top: 25px;
    margin-bottom: 10px;
  }

  ul {
    padding-left: 1.2rem;
    margin-bottom: 20px;

    li {
      margin-bottom: 10px;
    }
  }
}

/* Responsive */
@media only screen and (max-width: 767px) {
  .services-details-img {
    flex-direction: column;
    align-items: center;

    .top-banner-img {
      width: 100%;
      max-height: 220px;
    }
  }

  .services-details-content h2 {
    font-size: 25px;
    margin-bottom: 15px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .services-details-img .top-banner-img {
    max-height: 300px;
  }

  .services-details-content h2 {
    font-size: 30px;
    margin-bottom: 15px;
  }
}
</style>
